<template>
  <div class="locations-wrap">

    <!-- <h1 class="header">Our Locations</h1> -->
    <draggable
      v-if="locations.length"
      v-model="locations"
      class="locations"
      :options="{draggable:'.menu'}" @start="drag=true" @end="drag=false"
    >
      <location-menus
        v-for="post in locations"
        :location="post"
        :key="post.id"
        :isEditable="locationIsEditable(post)"
        @singleClick="enableEditMode(post)"
        @clickAway="disableEditMode(post)"
      />
    </draggable>
  </div>
</template>

<script>

import _ from 'lodash'
import axios from 'axios'

import { mapState, mapGetters } from 'vuex'
  
import draggable from 'vuedraggable'
import EditableTextField from '../EditableTextField'

import LocationMenus from './LocationMenus'

export default {

  name: 'LocationsList',
  components : {
    draggable,
    'editable-text' : EditableTextField,
    'location-menus' : LocationMenus
  },
  props : {},

  data () {
    return {
      apiResponse : '',
      wpLocations : [],
      menu_order : 0,
      originalData : [],
      authToken : null
    }
  },
  computed: {
    ...mapState(['locations', 'wpData']),
    ...mapGetters(['isAuthenticated']),
    _() {
      return _;
    }
  },
  mounted() {
    if( !this.locations.length ) {
      this.getLocations();
    }
  },
  methods : {
    locationIsEditable( post ) {
      return post.editable && !post.disabled && this.isAuthenticated;
    }, // locationIsEditable()

    toggleEditMode( post ) {
      this.setLocProp( post, 'editable', !post.editable);
    }, // toggleEditMode

    enableEditMode( post ) {
      this.setLocProp( post, 'editable', true);
    }, // enableEditMode

    disableEditMode( post ) {
      this.setLocProp( post, 'editable', false);
    },

    setLocProp(post, key, val) {
      let post_id = post.id;

      // Update the Loc item by cloning and modifying it,
      // then splicing the wpLocations obj
      let index = _.findIndex(this.wpLocations, function(post) { return post.id == post_id });
      let tmpLoc = _.clone(this.wpLocations[ index ]);
      tmpLoc[ key ] = val;
      this.wpLocations.splice( index, 1, tmpLoc );
      
    }, // setMenuProp

    async getLocations() {
      try {
        const restURL = this.wpData.rest_url;
        const postsPerPage = 100; // default is 10.
        const fields = 'id,title,vue_meta,acf,menu_order'; // retrieve data for specific fields only.
        
        let includeString = '';
        let response;
        if( typeof this.wpData.location !== "undefined" && this.wpData.location !== -1 ) {
          includeString += `&include[]=${this.wpData.location}`;
          // response = await this.$store.state.wpapi.locations().include(this.wpData.location);
          response = await axios( `${this.wpData.rest_url}/wp/v2/${this.wpData.cpts.locations}?${includeString}` )

        }
        // if this is NOT a menu board, load all the friggin
        // locations you can find
        else if( this.wpData.menu_board_id < 0 ) {
          response = await axios( `${this.wpData.rest_url}/wp/v2/${this.wpData.cpts.locations}` )
          // response = await this.$store.state.wpapi.locations();
        }

        this.wpLocations = response.data;

        this.originalData = _.clone(this.wpLocations); 
        this.$store.commit('setLocations', this.wpLocations);
        return true;
      }

      catch ( error ) {
        this.apiResponse = ` The request could not be processed! <br> <strong>${error}</strong> `;
      }
    }, // getLocations

  }
}
</script>

<style lang="scss">
.header {
  color:#DF7046;
  text-align:center;
  font-family: 'Jaldi', sans-serif;
  text-transform:uppercase;
  letter-spacing:1px;
  // text-decoration:underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Location/LocationsList.vue